import React from "react";
import { useLanguage } from "../LanguageContext";

const Services: React.FC = () => {
    const { t } = useLanguage();
    const s = t.services;
    return (
        <section className="services" id="services">
            <div className="section-number">02</div>
            <div className="container">
                <div className="services-header">
                    <span className="section-eyebrow">{s.eyebrow}</span>
                    <h2 className="section-title">{s.title}</h2>
                </div>
                <div className="services-grid">
                    {s.items.map(item => (
                        <div className="service-card" key={item.num}>
                            <div className="service-num">{item.num}</div>
                            <div className="service-line" />
                            <h3>{item.title}</h3>
                            <p>{item.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;
